export default __webpack_public_path__ + "static/media/phone.dd7e353f.png";